import { render, staticRenderFns } from "./agronomo.vue?vue&type=template&id=4575aa9d&"
import script from "./agronomo.vue?vue&type=script&lang=js&"
export * from "./agronomo.vue?vue&type=script&lang=js&"
import style0 from "./agronomo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports